import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import type { RetailPriceReportStore, Filters } from './types'
import type {
  RetailDashboard_MerchantStatsFragment,
  RetailDashboard_MerchantSelectorDataFragment,
} from 'api/operations'
import { ls } from 'utils/my-localstorage'
import { defaultCurrencyValue } from 'components/Pages/Retail/PriceReport/Content/_methods'

const getInitialStartDate = () => {
  const storedDate = ls.getItem('wwl-price-report-start-date')
  return storedDate ? storedDate : null
}
const initialState: RetailPriceReportStore = {
  loadingMerchant1: true,
  loadingMerchant2: true,
  query: '',
  filters: [],
  merchant1: null,
  merchantData1: null,
  merchant2: null,
  merchantData2: null,
  isTutorialOpen: false,
  currency: defaultCurrencyValue,
  startDate: getInitialStartDate(),
}
export interface CurrencyRetailPriceReport {
  id: number | null
  code: string
  symbol: string
}
const retailPriceReportSlice = createSlice({
  name: 'retailPriceReport',
  initialState,
  reducers: {
    setLoadingMerchant1: (state, { payload }) => {
      state.loadingMerchant1 = payload
    },
    setLoadingMerchant2: (state, { payload }) => {
      state.loadingMerchant2 = payload
    },
    setFilters: (state, { payload }: PayloadAction<Filters>) => {
      state.filters = payload
    },
    setIsTutorialOpen: (state, { payload }) => {
      state.isTutorialOpen = payload
    },

    setMerchant1: (
      state,
      {
        payload,
      }: PayloadAction<RetailDashboard_MerchantSelectorDataFragment | null>
    ) => {
      state.merchant1 = payload
    },
    setMerchantData1: (
      state,
      { payload }: PayloadAction<RetailDashboard_MerchantStatsFragment | null>
    ) => {
      state.merchantData1 = payload
    },
    setMerchant2: (
      state,
      {
        payload,
      }: PayloadAction<RetailDashboard_MerchantSelectorDataFragment | null>
    ) => {
      state.merchant2 = payload
    },
    setMerchantData2: (
      state,
      { payload }: PayloadAction<RetailDashboard_MerchantStatsFragment | null>
    ) => {
      state.merchantData2 = payload
    },
    setCurrency: (
      state,
      { payload }: PayloadAction<CurrencyRetailPriceReport | null>
    ) => {
      state.currency = payload
    },
    setStartDate: (state, { payload }) => {
      state.startDate = payload
    },
    reset: () => {
      return initialState
    },
  },
})

export const { actions, reducer: retailPriceReport } = retailPriceReportSlice
export const {
  setLoadingMerchant1,
  setLoadingMerchant2,
  setFilters,
  reset,
  setMerchant1,
  setMerchant2,
  setIsTutorialOpen,
  setCurrency,
  setStartDate,
  setMerchantData1,
  setMerchantData2,
} = actions
